import { SET_EDIT_APP_PAGE, SET_EXAMPLE_TILE } from "./constants";

export const setEditAppPage = (page) => ({ type: SET_EDIT_APP_PAGE, page });
export const setExampleTile = (data) => ({ type: SET_EXAMPLE_TILE, data });
